import { gql } from '@apollo/client';
import { crewMemberFragments } from '~/gql/crew-member';

const fragments = {
  crewChangeRequestStatus: gql`
    fragment CrewChangeRequestStatus on CrewChangeRequest {
      id
      currentStatus
      statusHistory {
        status
        createdAt
        createdBy {
          ...CrewMemberExpanded
        }
      }
    }
    ${crewMemberFragments.crewMemberExpanded}
  `,
  crewChangeRequestItem: gql`
    fragment CrewChangeRequestItem on CrewChangeRequest {
      id
      originCrew {
        id
        crewNumber
        generalForeman {
          ...CrewMemberCompact
        }
        foreman {
          ...CrewMemberCompact
        }
      }
      destinationCrew {
        id
        crewNumber
        generalForeman {
          ...CrewMemberCompact
        }
        foreman {
          ...CrewMemberCompact
        }
      }
      moveType
      affectedCrewMembers {
        ...CrewMemberCompact
      }
    }
    ${crewMemberFragments.crewMemberCompact}
  `,
};
export const GET_CREW_CHANGE_REQUESTS = gql`
  query crewChangeRequests($input: SearchCrewChangeRequestInput, $paging: PagingRowNumberInput) {
    crewChangeRequests(input: $input, paging: $paging)  {
      total
      rowNumber
      items {
        id
        originCrew {
          id
          crewNumber
          superintendent {
            id
          }
          generalForeman {
            ...CrewMemberCompact
          }
          foreman {
            ...CrewMemberCompact
          }
        }
        destinationCrew {
          id
          crewNumber
          superintendent {
            id
          }
          generalForeman {
            ...CrewMemberCompact
          }
          foreman {
            ...CrewMemberCompact
          }
        }
        moveType
        affectedCrewMembers {
          ...CrewMemberCompact
        }
        currentStatus
        statusHistory {
            status
            createdAt
            createdBy {
              ...CrewMemberCompact
            }
        }
      }
    }
    ${crewMemberFragments.crewMemberCompact}
  }
`;

export const GET_CREW_CHANGE_REQUEST_BY_IDs = gql`
  query crewChangeRequestsByIds($ids: [ID!]!) {
    crewChangeRequestsByIds(ids: $ids) {
      id
      originCrew {
          id
          crewNumber
          superintendent {
            ...CrewMemberExpanded
          }
          generalForeman {
            ...CrewMemberExpanded
          }
          foreman {
              ...CrewMemberExpanded
          }
      }
      destinationCrew {
          id
          crewNumber
          superintendent {
            ...CrewMemberExpanded
          }
          generalForeman {
            ...CrewMemberExpanded
          }
          foreman {
              ...CrewMemberExpanded
          }
      }
      currentStatus
      statusHistory {
          status
          createdAt
          createdBy
          {
            ...CrewMemberExpanded
          }
        }
      comments
      moveType
      affectedCrewMembers {
          ...CrewMemberExpanded
      }
    }
    ${crewMemberFragments.crewMemberExpanded}
  }
`;

export const ADD_CREW_CHANGE_REQUEST = gql`
  mutation addCrewChangeRequest($input: AddCrewChangeRequestInput!) {
    addCrewChangeRequest(input: $input) {
      crewChangeRequest {
        id
        currentStatus
      }
      error
    }
  }
`;

export const GET_CREW_CHANGE_PENDING_REQUESTS = gql`
  query crewChangePendingRequests($input: SearchCrewChangeRequestInput, $paging: PagingRowNumberInput) {
    crewChangeRequests(input: $input, paging: $paging)  {
      total
      rowNumber
      items {
        ...CrewChangeRequestItem
      }
    }
    ${fragments.crewChangeRequestItem}
  }
`;

export const APPROVE_ALL_CREW_CHANGE_REQUESTS = gql`
  mutation approveAllCrewChangeRequests {
    approveAllCrewChangeRequests {
      crewChangeRequests {
        ...CrewChangeRequestStatus
      }
      erroredCrewChangeRequests {
        error
        crewChangeRequest {
          ...CrewChangeRequestItem
        }
      }
    }
    ${fragments.crewChangeRequestStatus}
    ${fragments.crewChangeRequestItem}
  }
`;

export const APPROVE_CREW_CHANGE_REQUEST = gql`
  mutation approveCrewChangeRequest ($crewChangeRequestId: ID!) {
    approveCrewChangeRequest(crewChangeRequestId: $crewChangeRequestId) {
      crewChangeRequest {
        ...CrewChangeRequestStatus
      }
      error
    }
    ${fragments.crewChangeRequestStatus}
}
`;

export const DECLINE_CREW_CHANGE_REQUEST = gql`
  mutation declineCrewChangeRequest ($crewChangeRequestId: ID!) {
    declineCrewChangeRequest(crewChangeRequestId: $crewChangeRequestId) {
      crewChangeRequest {
        ...CrewChangeRequestStatus
      }
      error
    }
    ${fragments.crewChangeRequestStatus}
}
`;

export const CANCEL_CREW_CHANGE_REQUEST = gql`
  mutation cancelCrewChangeRequest ($crewChangeRequestId: ID!) {
    cancelCrewChangeRequest(crewChangeRequestId: $crewChangeRequestId) {
      crewChangeRequest {
        ...CrewChangeRequestStatus
      }
      error
    }
    ${fragments.crewChangeRequestStatus}
}
`;

export const GET_CREW_CHANGE_STATS = gql`
  query crewChangeStats($input: CrewChangeStatInput) {
    crewChangeStats(input: $input) {
      approvals {
        statType
        total
      }
      requests {
        statType
        total
      }
    }
  }
`;

export const SUBSCRIPTION_CREW_CHANGE_REQUEST_ACTION = gql`
  subscription onCrewChangeRequestAction {
    crewChangeRequest {
      crewChangeRequestIds
      crewChangeActionType
      lastActionAt
    }
  }
`;

export const SUBSCRIPTION_CREW_UPDATE = gql`
  subscription crewUpdated {
    crewUpdated {
      affectedCrewMembers {
        personaTypeId
        hierarchy {
          superintendentId
          foremanId
          generalForemanId
        }
      }
    }
  }
`;
